export default __webpack_public_path__ + "static/public-professional-f189677048dd0f79f63e9e5c5a016fd0.webp";